export class KeystrokeDNA {
  constructor(mount) {
    this.mount = mount;
    this.mount.classList.add('keystroke-dna');
    this.mount.innerHTML = `
      <svg viewBox="0 0 300 48" preserveAspectRatio="none" aria-hidden="true">
        <path class="ref" d="" />
        <path class="live" d="" />
      </svg>
    `;
    this.svg = this.mount.querySelector('svg');
    this.refPath = this.mount.querySelector('path.ref');
    this.livePath = this.mount.querySelector('path.live');
  }

  update(iki) {
    if (!iki || iki.length < 2) {
      this.livePath.setAttribute('d', '');
      return;
    }
    this.livePath.setAttribute('d', ikiToPath(iki, 300, 48));
  }

  showReference(reference) {
    if (!reference || reference.length < 2) {
      this.refPath.setAttribute('d', '');
      return;
    }
    this.refPath.setAttribute('d', ikiToPath(reference, 300, 48));
  }

  flashSync() {
    this.mount.classList.remove('synced');
    void this.mount.offsetWidth;
    this.mount.classList.add('synced');
    setTimeout(() => this.mount.classList.remove('synced'), 900);
  }

  reset() {
    this.livePath.setAttribute('d', '');
    this.refPath.setAttribute('d', '');
  }
}

function ikiToPath(iki, width, height) {
  const max = Math.max(...iki, 300);
  const step = width / (iki.length - 1 || 1);
  const points = iki.map((v, i) => {
    const x = i * step;
    const clamped = Math.min(v, max);
    const y = height - (clamped / max) * (height * 0.85) - 3;
    return [x, y];
  });
  let d = `M ${points[0][0]} ${points[0][1]}`;
  for (let i = 1; i < points.length; i++) {
    const [px, py] = points[i - 1];
    const [cx, cy] = points[i];
    const mx = (px + cx) / 2;
    d += ` Q ${mx} ${py} ${cx} ${cy}`;
  }
  return d;
}
